import { STRINGS } from "../../utils/strings";
import CancelButton from "../Buttons/CancelButton";
import SaveButton from "../Buttons/SaveButton";

export default function ModalActions({ onReset, onSave, disabled, mode }) {
  return (
    <div className="flex flex-row gap-2 w-1/2">
      <CancelButton className="w-1/2" disabled={disabled} onClick={onReset} />
      <SaveButton
        className="w-1/2"
        disabled={disabled}
        onClick={onSave}
        label={mode === STRINGS.ADD_MODE ? "Add Note" : "Update Note"}
      />
    </div>
  );
}
